import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTION_COUNTRY_GRADUAL_OPENING = createFcmDetails('promotion_country_gradual_opening', {
	owner: 'TBD',
	context: 'Promotion flow',
	description: 'Allows to open traffic to the promotion flow based on a percentage.',
	import: false,
	template: {
		traffic_percentage: 100,
		safe_listed_user_identifiers: [],
		block_listed_user_identifiers: [],
	},
});
